import React from 'react';
import { DepositTrackerWidget } from './DepositTrackerWidget';
import { RekeyStatusWidget } from './RekeyStatusWidget';
import { RentalRegistrationWidget } from './RentalRegistrationWidget';
import { DepositItem, RekeyUnit, RentalRegistration } from '../../services/texasComplianceService';
import { getAppMarket } from '../../services/MarketService';

export interface TexasComplianceWidgetsProps {
  onDepositClick?: (deposit: DepositItem) => void;
  onRekeyUnitClick?: (unit: RekeyUnit) => void;
  onRegistrationClick?: (reg: RentalRegistration) => void;
  onPropertyClick?: (propertyId: string) => void;
  propertyManagerFilter?: string;
  className?: string;
  isTexasOnly?: boolean;
}

export const TexasComplianceWidgets: React.FC<TexasComplianceWidgetsProps> = ({
  onDepositClick,
  onRekeyUnitClick,
  onRegistrationClick,
  onPropertyClick,
  propertyManagerFilter,
  className = '',
  isTexasOnly = false,
}) => {
  const isTexas = isTexasOnly
    ? (typeof window !== 'undefined' &&
        ['tx', 'texas'].includes(
          (localStorage.getItem('selected_jurisdiction') || localStorage.getItem('jurisdiction'))?.toLowerCase() || ''
        ))
    : getAppMarket() === 'texas';

  if (!isTexas) {
    return null;
  }

  return (
    <div
      data-testid="texas-compliance-widgets-container"
      className={'space-y-4 ' + className}
    >
      <div className="flex items-center justify-between mb-1">
        <h2 className="text-base font-bold text-gray-900 flex items-center gap-2">
          <span className="w-2.5 h-2.5 rounded-full bg-red-600 inline-block"></span>
          Texas Regulatory Compliance
          <span className="text-xs font-semibold px-2 py-0.5 bg-red-50 text-red-700 rounded-full border border-red-200">
            Texas Property Code & Municipal
          </span>
        </h2>
        <span className="text-xs text-gray-500">
          Independent live widgets
        </span>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {/* Widget 1: Deposit Tracker (T-222-001) */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <DepositTrackerWidget
            onDepositClick={onDepositClick}
            onPropertyClick={onPropertyClick}
          />
        </div>

        {/* Widget 2: 7-Day Rekey Status (T-222-002) */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <RekeyStatusWidget
            onUnitClick={onRekeyUnitClick}
            onPropertyClick={onPropertyClick}
            propertyManagerFilter={propertyManagerFilter}
          />
        </div>

        {/* Widget 3: Municipal Rental Registrations (T-222-003) */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <RentalRegistrationWidget
            onRegistrationClick={onRegistrationClick}
            onPropertyClick={onPropertyClick}
          />
        </div>
      </div>
    </div>
  );
};

export default TexasComplianceWidgets;
